// Mock data for SGS Global Media website

export const companyInfo = {
  name: "SGS Global Media",
  tagline: "Empowering Businesses with Guaranteed Leads, Revenue Growth, and AI Automation",
  description: "Helping businesses generate predictable leads, convert high-ticket clients, and automate growth using paid ads, funnels, and smart automation.",
  email: "info.sgsglobalmedia@gmail.com",
  phone: "+1 (555) 123-4567",
  address: "Balewadi High Street, Pune City, Maharashtra, India",
  calendlyLink: "https://calendly.com/info-sgsglobalmedia/30min"
};

export const services = [
  {
    id: 1,
    title: "Lead Generation",
    description: "High-intent leads sourced from the platforms your customers actually use.",
    icon: "target",
    features: [
      "Targeted audience research",
      "Lead magnet creation",
      "Landing page optimization",
      "Multi-channel campaigns"
    ]
  },
  {
    id: 2,
    title: "Sales Funnels",
    description: "Static websites don't sell. We build VSLs and booking systems designed to convert.",
    icon: "filter",
    features: [
      "Funnel strategy & mapping",
      "Email automation sequences",
      "Conversion optimization",
      "A/B testing & analytics"
    ]
  },
  {
    id: 3,
    title: "CRM & AI Automation",
    description: "Never lose a lead to slow follow-up. Automated sequences that keep your pipeline moving.",
    icon: "zap",
    features: [
      "CRM implementation & setup",
      "AI-powered chatbots",
      "Workflow automation",
      "Customer data analytics"
    ]
  },
  {
    id: 4,
    title: "Web Development",
    description: "High-converting, conversion-optimized websites and applications built for performance and growth.",
    icon: "globe",
    features: [
      "Responsive web design",
      "Landing pages & VSLs",
      "Performance optimization",
      "Integrations & APIs"
    ]
  }
];

export const aboutContent = {
  title: "About SGS Global Media",
  subtitle: "End-to-End Growth Systems",
  paragraphs: [
    "At SGS Global Media, we believe in building end-to-end growth systems designed to scale revenue — not vanity metrics. Founded by a team of performance marketing experts, we combine cutting-edge AI automation with proven sales funnels.",
    "Our mission is to help businesses generate predictable, scalable revenue through strategic lead generation and intelligent automation. Whether you're launching your first campaign or scaling to 7 figures, we have the systems to make it happen.",
    "We specialize in high-intent lead generation, conversion-optimized funnels, and AI-powered CRM systems that never let a lead slip through the cracks."
  ]
};

export const navigationLinks = [
  { label: "Our Systems", path: "#services" },
  { label: "About",       path: "#about"    },
  { label: "Process",     path: "#process"  },
  { label: "FAQ",         path: "#faq"      },
  { label: "Contact",     path: "#contact"  },
];
